
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
  className?: string;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'font-medium rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer min-h-[44px] flex items-center justify-center';
  
  const variantClasses = {
    primary: 'bg-brand-red text-white hover:bg-brand-blue hover:text-white border-2 border-brand-red hover:border-brand-blue',
    secondary: 'bg-brand-blue text-white hover:bg-brand-red hover:text-white border-2 border-brand-blue hover:border-brand-red',
    outline: 'bg-transparent text-brand-red border-2 border-brand-red hover:bg-brand-red hover:text-white'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
